import React from "react";

function HelpBox() {
  return (
    <div className="help_box">
      <div className="txt_box">
        <div className="t f_48 wow fadeInUp">
          <p> WeKruit - Your Recruiting Journey, Reimagined.</p>
          <p>
            We know it’s
            <span className="color_red"> overwhelming</span>. Let’s win this
            together.
          </p>
        </div>
        <div className="icon1">
          <img className="wow zoomIn" src="./images/hicon1.svg" alt="" />
        </div>
        <div className="icon2">
          <img className="wow zoomIn" src="./images/hicon2.svg" alt="" />
        </div>
        <div className="icon3">
          <img className="wow zoomIn" src="./images/hicon3.svg" alt="" />
        </div>
      </div>
      <a
        href="https://wekruit-case-interview.web.app/dashboard"
        className="wow fadeInUp"
      >
        Get Started Today
      </a>
    </div>
  );
}

export default HelpBox;
